import ProductAPI from "@api/lol/Product.api";
import type IProduct from "@api/models/IProduct";
import type { AppRegion } from "@core-types/region.enum";
import { useAppRegion } from "@hooks/region/useAppRegion";
import getAvailableAccountIds from "@modules/order/hooks/getAvailableAccountIds.hook";
import { useLoLProductAsBasketAccount } from "@modules/order/hooks/useBasketItem.hook";
import useBuyModalStore from "@store/buyModal.store";
import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router";

export const useLolProductDetails = () => {
  const [product, setProduct] = useState<IProduct | undefined>(undefined);
  const { slug } = useParams();
  const { getFirstAvailableId } = getAvailableAccountIds(
    product?.accounts ?? [],
  );
  const { open } = useBuyModalStore();
  const { changeRegion, currentRegion } = useAppRegion();

  const onRegionChange = (newRegion: AppRegion) => {
    changeRegion(newRegion, loadData);
  };

  const loadData = useCallback(() => {
    if (!slug) return;

    ProductAPI.getProductBySlug(slug).then((res) => {
      setProduct(res.data);
    });
  }, [slug]);

  const handleBuyModal = () => {
    if (!product) return;

    open(
      useLoLProductAsBasketAccount(
        product,
        getFirstAvailableId(),
        currentRegion,
      ),
    );
  };

  useEffect(() => {
    loadData();
  }, [loadData]);

  return {
    loadData,
    onRegionChange,
    product,
    handleBuyModal,
  };
};
